import { fetcher, Pagination, PaginationResponse } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import qs from "query-string";
import { Applicant } from "@/shared/core-vouchers";

export const GET_APPLICANTS_FETCH_KEY = "GET_APPLICANTS_FETCH_KEY";

type GetApplicantsParams = {
  zoneIds?: string[] | string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
  companyId?: string;
} & Partial<Pagination>;

export const getApplicants = async (
  zoneIds?: string[] | string,
  showDisabled?: boolean,
  page?: number,
  pageSize?: number,
  searchTerm?: string,
  sort?: string,
  order?: string,
  companyId?: string,
) => {
  const queryString = qs.stringify({
    zoneIds,
    showDisabled,
    page,
    pageSize,
    searchTerm,
    sort,
    order,
    companyId,
  });
  const response = await fetcher.get(
    `${API.GESLUB}/productApplicant?${queryString}`,
  );
  return response.data;
};

export const useGetApplicants = ({
  page,
  pageSize,
  showDisabled,
  zoneIds,
  searchTerm,
  sort,
  order,
  companyId,
}: GetApplicantsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<Applicant>,
    Error
  >({
    queryKey: [
      GET_APPLICANTS_FETCH_KEY,
      zoneIds,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      sort,
      order,
      companyId,
    ],
    queryFn: () =>
      getApplicants(
        zoneIds,
        showDisabled,
        page,
        pageSize,
        searchTerm,
        sort,
        order,
        companyId,
      ),
    placeholderData: (prev) => prev,
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
